import { liteClient, type LiteClient } from 'algoliasearch/lite'

/**
 * Gemeinsame Client-Factory für alle InstantSearch-Blöcke. Ist über YT_CONFIG
 * ein Proxy-Host konfiguriert (Cloudflare Worker, cacht identische Queries),
 * laufen alle Requests darüber; die Original-Algolia-Hosts bleiben als
 * Fallback in der Retry-Kette, falls der Proxy nicht antwortet.
 */
export default function createSearchClient(
  appId: string,
  apiKey: string
): LiteClient {
  const proxyHost = window.YT_CONFIG?.algoliaProxyHost
  if (!proxyHost) {
    return liteClient(appId, apiKey)
  }
  const client = liteClient(appId, apiKey, {
    timeouts: {
      connect: 4000,
      read: 2000,
      write: 30000
    },
    hosts: [
      { url: proxyHost, accept: 'readWrite', protocol: 'https' },
      { url: `${appId}-dsn.algolia.net`, accept: 'read', protocol: 'https' },
      { url: `${appId}-1.algolianet.com`, accept: 'readWrite', protocol: 'https' },
      { url: `${appId}-2.algolianet.com`, accept: 'readWrite', protocol: 'https' },
      { url: `${appId}-3.algolianet.com`, accept: 'readWrite', protocol: 'https' }
    ]
  })
  const siteSlug = window.YT_CONFIG?.siteSlug
  if (siteSlug) {
    client.addAlgoliaAgent('icf-site', siteSlug)
  }
  return client
}
